import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexSweetalert',
  setup(__props) {

const BasicAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/BasicAlert.vue"))
const TextUnder = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/TextUnder.vue"))
const InfoAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/InfoAlert.vue"))
const WarningAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/WarningAlert.vue"))
const PikachuAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/PikachuAlert.vue"))
const QuestionsAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/QuestionsAlert.vue"))
const UsernameAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/UsernameAlert.vue"))
const SuccessMessage = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/SuccessMessage.vue"))
const DangerAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/DangerAlert.vue"))
const WarningMode = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/WarningMode.vue"))
const AutoClose = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/AutoClose.vue"))
const RequestMovie = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/RequestMovie.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BasicAlert)),
      _createVNode(_unref(TextUnder)),
      _createVNode(_unref(InfoAlert)),
      _createVNode(_unref(WarningAlert)),
      _createVNode(_unref(PikachuAlert)),
      _createVNode(_unref(QuestionsAlert)),
      _createVNode(_unref(UsernameAlert)),
      _createVNode(_unref(SuccessMessage)),
      _createVNode(_unref(DangerAlert)),
      _createVNode(_unref(WarningMode)),
      _createVNode(_unref(AutoClose)),
      _createVNode(_unref(RequestMovie))
    ])
  ]))
}
}

})